import { ProductClass } from '../../graphQL/types/shared';
import {
  average,
  ICYDatum,
  ILoadable,
  LoadableStatus,
} from '../../Utils';
import {
  IAssignGroupOutput,
  IFilteredByYearOutput,
} from './Utils';

const filter = (
    currentYear: number,
    assignedGroupStatus: ILoadable<IAssignGroupOutput>,
    countryYearDataStatus: ILoadable<ICYDatum[]>,
    productClass: ProductClass,

  ): ILoadable<IFilteredByYearOutput> => {

  let result: ILoadable<IFilteredByYearOutput>;
  if (assignedGroupStatus.status === LoadableStatus.Initial ||
      countryYearDataStatus.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (assignedGroupStatus.status === LoadableStatus.Loading ||
              countryYearDataStatus.status === LoadableStatus.Loading) {
    result = {status: LoadableStatus.Loading};
  } else if (assignedGroupStatus.status === LoadableStatus.NotPresent ||
              countryYearDataStatus.status === LoadableStatus.NotPresent) {
    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: {
      nodes: unfiltered,
      minWorldTrade, maxWorldTrade,
      minOpportunityGain, maxOpportunityGain,
      minDistance, maxDistance,
      minComplexity, maxComplexity,
    }} = assignedGroupStatus;
    const {data: countryYearData} = countryYearDataStatus;

    const withTrade = unfiltered.filter(({year}) => year === currentYear);

    const notExportedProducts = withTrade.filter(({export_rca}) => export_rca < 1);

    let averageComplexity: number;
    if (productClass === ProductClass.HS) {
      const {hs_eci} = countryYearData.find(({year}) => year === currentYear)!;
      averageComplexity = hs_eci;
    } else {
      const {eci} = countryYearData.find(({year}) => year === currentYear)!;
      averageComplexity = eci;
    }

    const allOpportunityGains = notExportedProducts.map(({cog}) => cog);

    result = {
      status: LoadableStatus.Present,
      data: {
        nodes: withTrade,
        minWorldTrade, maxWorldTrade,
        minOpportunityGain, maxOpportunityGain,
        minDistance, maxDistance,
        minComplexity, maxComplexity,
        averageComplexity,
        averageOpportunityGain: average(allOpportunityGains),
      },
    };
  }
  return result;
};

export default filter;
